var _defs, _path, _g, _g2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToken33T(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#708b96;}.cls-2{isolation:isolate;}.cls-3{fill:#fff;}.cls-4{fill:#d1ceaa;}\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111,498.35c0-214.8,174.2-389,389-389s389,174.2,389,389-174.2,389-389,389S111,713.15,111,498.35Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text20110",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.71,642.85v40.21h-5.89V642.85H299v-5.63h31.5v5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.24,660.14a23.21,23.21,0,0,1-6.79,17,23.8,23.8,0,0,1-33.54,0,24.75,24.75,0,0,1,0-34.06,23.72,23.72,0,0,1,33.54.07A23.12,23.12,0,0,1,390.24,660.14Zm-41.1,0a18.13,18.13,0,0,0,5,13.12,16.82,16.82,0,0,0,12.55,5.19,16.59,16.59,0,0,0,12.48-5.19,19.54,19.54,0,0,0,0-26.24,16.59,16.59,0,0,0-12.48-5.19A16.82,16.82,0,0,0,354.13,647,18.13,18.13,0,0,0,349.14,660.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M451.31,662q0,9.6-5.69,15.3-6.4,6.78-16.84,6.78a23.94,23.94,0,1,1,0-47.88,25.56,25.56,0,0,1,9.54,1.79,19,19,0,0,1,7.36,5.06l-4.22,4.22a14.31,14.31,0,0,0-5.48-4,18.08,18.08,0,0,0-7.2-1.44A17.25,17.25,0,0,0,416.1,647a19.37,19.37,0,0,0,0,26.24,17.25,17.25,0,0,0,12.68,5.19,17.07,17.07,0,0,0,11.4-3.84,15.34,15.34,0,0,0,5.25-10.56H428.78v-5.51H451A19,19,0,0,1,451.31,662Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M495.87,637.22v5.63H475v14.54h18.82v5.5H475v14.54h20.87v5.63H469.11V637.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M530.06,642.85v40.21h-5.89V642.85H511.36v-5.63h31.5v5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M565.52,683.06h-5.89V637.22h5.89v19.66h22.92V637.22h5.89v45.84h-5.89V662.38H565.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M640.94,637.22v5.63H620.07v14.54h18.82v5.5H620.07v14.54h20.87v5.63H614.18V637.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M665.39,683.06H659.5V637.22h15.62a14.28,14.28,0,0,1,10.15,3.94,13.17,13.17,0,0,1,1.09,18.12,13.79,13.79,0,0,1-7.84,4.7l-.13.19,12.87,18.63v.26h-7l-12.36-18.57h-6.53Zm0-40.21V659h9.48a8.55,8.55,0,0,0,6.08-2.34,7.64,7.64,0,0,0,2.5-5.79,8.11,8.11,0,0,0-8.2-8Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g93605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path93601",
    className: "cls-3",
    d: "M537.9,302.69l.26,63.46,32.49.22c8.73-18.92,24.19-35.55,49.83-35.58s47,22.23,46.91,45.38c0,28.15-23.62,50.24-47.62,50.48-14.55.14-31.34-1.8-46.92-13.92l-34.49-.39.2,75.46h33.68C592,474.07,605.93,473,617.5,473c23,0,48.78,17.53,49,46.15s-21.58,49.45-45.26,49.22c-24.21-.23-42.51-14.94-48.58-34.45l-33.81-.35-.58,63.2,28.23.24.28-19.77c13.48,14.16,38.14,21.38,51.51,21.22,45.16-.54,76.89-41,77.14-78.53s-23-59.23-43.53-70.09c17.85-8.6,44.31-32.21,44-73.94s-38.46-75.08-76.5-75.12c-21.37,0-39.59,10.3-52.57,21.63l-.17-19.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93603",
    className: "cls-3",
    d: "M325.64,302.78l.26,63.46,32.49.22c8.73-18.92,24.2-35.56,49.84-35.59s47,22.24,46.91,45.39c-.05,28.14-23.62,50.24-47.62,50.47-14.56.14-31.34-1.79-46.92-13.91l-34.49-.39.2,75.46H360c19.73-13.74,33.69-14.84,45.26-14.84,23,0,48.77,17.53,49,46.15S432.64,568.65,409,568.42c-24.21-.23-42.51-14.94-48.58-34.45l-33.8-.35-.58,63.2,28.23.23.28-19.76C368,591.45,392.63,598.67,406,598.51c45.15-.55,76.89-41,77.14-78.53s-23-59.23-43.53-70.1c17.84-8.59,44.31-32.2,44-73.93s-38.46-75.08-76.49-75.12c-21.37,0-39.59,10.29-52.57,21.63L354.42,303Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M499.5,937.6c240.8,0,436-195.2,436-436a436.24,436.24,0,0,0-24.4-144.3V215.2a497.78,497.78,0,0,1,89,284.8c0,276.1-223.9,500-500,500S0,776.1,0,500A498,498,0,0,1,90,213.7V351.5A434.38,434.38,0,0,0,63.5,501.6C63.5,742.4,258.7,937.6,499.5,937.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken33T);
export default __webpack_public_path__ + "static/media/token_33T.d541d6e5.svg";
export { ForwardRef as ReactComponent };